import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { IntroSection } from '../components/IntroSection';
import { NewsletterSection } from '../components/NewsletterSection';
import { Button } from '../components/ui/Button';
import { Brain, Heart, Sparkles, Calendar, MessageSquare, Footprints } from 'lucide-react';
import { navigate, BOOKING_URL } from '../lib/navigation';
export function Home() {
  const steps = [{
    icon: <Calendar className="w-6 h-6" data-id="element-386" />,
    title: 'Book a free consultation',
    desc: "A 15-minute video call to see if we're a good fit"
  }, {
    icon: <MessageSquare className="w-6 h-6" data-id="element-387" />,
    title: "We'll talk about it",
    desc: "Share what you're going through, no pressure"
  }, {
    icon: <Footprints className="w-6 h-6" data-id="element-388" />,
    title: 'Start arriving at yourself',
    desc: 'Begin building a life that actually feels like yours'
  }];
  return <div className="animate-fade-in-up" data-id="element-389">
      <HeroSection data-id="element-390" />
      <IntroSection data-id="element-391" />

      {/* Combined: How We Work + Getting Started */}
      <section className="py-20 md:py-32 bg-sage/10" data-id="element-392">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-393">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-394">
            <h2 className="text-3xl md:text-4xl font-medium text-teal mb-4" data-id="element-395">
              How we'll work together
            </h2>
            <p className="text-xl text-teal/70" data-id="element-396">
              Evidence-based approaches to help you arrive at yourself
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-397">
            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-398">
              <div className="w-12 h-12 bg-sage/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-sage/30 transition-colors" data-id="element-399">
                <Brain className="w-6 h-6 text-sage" data-id="element-400" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-401">
                My Approach
              </h3>
              <p className="text-teal/80" data-id="element-402">
                I use CBT, DBT, mindfulness-based therapy, and narrative therapy
                to find what works for you.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-403">
              <div className="w-12 h-12 bg-terracotta/20 rounded-full flex items-center justify-center mb-6 group-hover:bg-terracotta/30 transition-colors" data-id="element-404">
                <Heart className="w-6 h-6 text-terracotta" data-id="element-405" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-406">
                Focus Areas
              </h3>
              <p className="text-teal/80" data-id="element-407">
                Specialising in anxiety, OCD, life transitions, and breaking
                people-pleasing patterns.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl hover:shadow-lg transition-all duration-300 hover:-translate-y-1 group cursor-pointer" onClick={() => navigate('#/services')} data-id="element-408">
              <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-teal/20 transition-colors" data-id="element-409">
                <Sparkles className="w-6 h-6 text-teal" data-id="element-410" />
              </div>
              <h3 className="text-xl font-semibold text-teal mb-4" data-id="element-411">
                Expectations
              </h3>
              <p className="text-teal/80" data-id="element-412">
                Real conversations, evidence-based tools, and a judgement-free
                space to be yourself.
              </p>
            </div>
          </div>

          {/* Getting Started Steps */}
          <div className="max-w-3xl mx-auto" data-id="element-413">
            <div className="text-center mb-12" data-id="element-414">
              <h3 className="text-2xl md:text-3xl font-medium text-teal mb-3" data-id="element-415">
                Ready to start?
              </h3>
              <p className="text-lg text-teal/70" data-id="element-416">
                Three simple steps to begin your journey
              </p>
            </div>

            <div className="space-y-8 mb-12" data-id="element-417">
              {steps.map((step, index) => <div key={index} className="flex items-start gap-6" data-id="element-418">
                  <div className="relative flex-shrink-0" data-id="element-419">
                    <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm border-2 border-sage/10" data-id="element-420">
                      <div className="text-terracotta" data-id="element-421">{step.icon}</div>
                    </div>
                    <div className="absolute -top-1 -right-1 w-7 h-7 bg-terracotta rounded-full flex items-center justify-center text-white font-bold text-xs" data-id="element-422">
                      {index + 1}
                    </div>
                    {index < steps.length - 1 && <div className="absolute top-16 left-1/2 -translate-x-1/2 w-0.5 h-8 bg-sage/20" data-id="element-423" />}
                  </div>
                  <div className="pt-2" data-id="element-424">
                    <h4 className="text-xl font-semibold text-teal mb-1" data-id="element-425">
                      {step.title}
                    </h4>
                    <p className="text-teal/70" data-id="element-426">{step.desc}</p>
                  </div>
                </div>)}
            </div>

            <div className="text-center" data-id="element-427">
              <Button size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-428">
                Book Your Free Consultation
              </Button>
            </div>
          </div>
        </div>
      </section>

      <NewsletterSection data-id="element-429" />
    </div>;
}